import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
// import { Actions as LEAVEACTIONS } from '../../store/actions/leaveActions';
import { Actions as EMPLOYEEACTIONS } from "../../../store/actions/employeeActions";

import AuditLogs from "../../auditLogs/AuditLogs";
import { format, addMonths } from "date-fns";

const EmployeeAuditLogs = ({ auditLogs, nextToken, agreementId }) => {
	return (
		<AuditLogs
			auditLogs={auditLogs}
			nextToken={nextToken}
			agreementId={agreementId}
		/>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		tab: state.employee.tab || "personal",
		auditLogs: (state.employee.auditLogs && state.employee.auditLogs.items) || [],
		nextToken: state.employee.auditLogs && state.employee.auditLogs.nextToken,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeAuditLogs);
